function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/orgs', {
      templateUrl: 'modules/app/orgs/orgs.html',
      controller: 'OrgsCtrl'
    });
  }]).
  /**
   * Org Selection
   */
  controller('OrgsCtrl', ['$scope', '$routeParams', '$location', '$window', '$http', 'User', '$cookies', 'Logger', 'Api', 'ConfirmModal', 'Interactions', 'TinCanJS', 'OrganizationContext', 'UserRoles', '$filter', 'Utils', function ($scope, $routeParams, $location, $window, $http, User, $cookies, Logger, Api, ConfirmModal, Interactions, TinCanJS, OrganizationContext, UserRoles, $filter, Utils) {
    // Set the headline
    $scope.$emit("headline:change", "hide");
    $scope.$emit("nav:change", "hide");
    $scope.orgFilter = '';
    $scope.memberships = [];
    $scope.dataLoaded = false;
    $scope.showReturnInactiveWarning = false;

    // Listen for 'Enter' when typing in the filter
    $scope.evalKeypress = function evalKeypress(event) {
      if (event.key === 'Enter') {
        var filteredMemberships = [];
        if ($scope.orgFilter.trim().length > 0) {
          filteredMemberships = $filter('filter')($scope.memberships, function (v) {
            return v.organization.name.toLowerCase().includes($scope.orgFilter.toLowerCase()) || v.organization.id.toString() === $scope.orgFilter;
          });
          // show a warning when 'select via "Enter" key' is disabled
          $scope.showReturnInactiveWarning = filteredMemberships.length > 1;
        } else {
          filteredMemberships = $scope.memberships.filter(function (membership) {
            return membership.organization.name === 'One True Demo';
          });
        }
        if (filteredMemberships.length > 0 && !$scope.showReturnInactiveWarning) {
          $scope.selectOrganization(filteredMemberships[0]);
        }
      } else {
        // hide 'select via "Enter" key' warning
        $scope.showReturnInactiveWarning = false;
      }
      if (event.key === 'Escape' || event.key === 'Esc') {
        $scope.orgFilter = '';
      }
    };
    $scope.search = function (init) {
      if (!init && !$scope.orgFilter) {
        $scope.loading = false;
        return;
      }
      var params = {
        "params": {
          "order_by": "organization.name",
          "_limit": 2000
        }
      };
      if ($scope.orgFilter) {
        params.params.org_name_query = $scope.orgFilter;
      }
      $http.get(Api.url("/users/me/memberships", true), params).then(function (response) {
        // Filter out the EMPTY org so we don't log in and later it or add ourselves as a
        // person accidentally.  EMPTY is used as a template for quick new org creation.
        var results = response.data.results.filter(function (membership) {
          return membership.organization.name !== "EMPTY";
        });

        // If we're entering the app under the context of a
        // particular org, find it and select it, otherwise,
        // send them to a join page.
        if (OrganizationContext.get() !== null) {
          var orgContext = OrganizationContext.get();
          var selectedOrgId = orgContext.id;

          // And clear it out as well, to avoid issues switching orgs later
          OrganizationContext.clear();
          var selectedMembership = null;
          angular.forEach(results, function (membership) {
            if (membership.organization.id === selectedOrgId) {
              selectedMembership = membership;
            }
          });
          if (selectedMembership !== null) {
            $scope.selectOrganization(selectedMembership);
            return;
          }
        }

        // If we're loading the first round of results, and the user only has one org -- Forward them to that org
        if (results.length === 1 && init) {
          // If the user belongs to a single org, store that info in order to hide the Organization
          // selector nav option per WSLRS-9025
          User.setBelongsToSingleOrg(true);
          $scope.selectOrganization(results[0], true);
          return;
        }
        $scope.dataLoaded = true;
        var alreadyLoadedTenantIds = $scope.memberships.map(function (t) {
          return t.tenant.id;
        });
        $scope.memberships = [].concat(_toConsumableArray($scope.memberships), _toConsumableArray(results.filter(function (r) {
          return !alreadyLoadedTenantIds.includes(r.tenant.id);
        })));
      }).catch(function () {
        $scope.dataLoaded = false;
      }).finally(function () {
        $scope.loading = false;
      });
    };
    $scope.nameFilter = function (value) {
      if (!$scope.orgFilter) {
        return true;
      }
      var filter = $scope.orgFilter.replace(/\s+/g, '.*?');
      var pattern = new RegExp(filter, 'gi');
      return Utils._try(function () {
        return value.organization.name.match(pattern);
      }, false);
    };
    $scope.showCreateOrg = UserRoles.isSystemAdmin(User.get());
    $scope.showOrgMetadata = UserRoles.isWatershedEmployee(User.get());

    //Function to select an organization and go into the application
    $scope.selectOrganization = function selectOrganization(membership) {
      if (membership.organization.expired && !UserRoles.isSystemAdmin(User.get())) {
        $scope.logout("expired", true);
        return;
      }
      var user = User.get();
      user.membership = membership;
      user.organization = user.membership.organization;
      User.set(user);

      // This is a dummy call made to avoid race conditions that can
      // arise when first time logins fetch lots of reports at once
      // See https://watershed.atlassian.net/browse/WSLRS-8282
      var hasStatements = Interactions.hasAny();
      if (user.organization.hasStatements) {
        hasStatements = Promise.resolve();
      }
      hasStatements.then(function () {
        $scope.$emit("organization-selected", membership.organization);
        TinCanJS.reload();

        // Is there some saved destination we should go?
        if (_.isUndefined($cookies.get('destination'))) {
          // Otherwise, onto the default path
          $location.path("/");
        } else {
          var destination = $cookies.get('destination');
          $cookies.remove('destination');
          $window.location.href = destination;
        }
      });
    };
    $scope.debouncedSearch = _.debounce(function () {
      $scope.loading = true;
      $scope.search();
    }, 1000);
    $scope.search(true);
  }]);
})();
